import React, { useEffect, useRef } from 'react';
import { getProjectFormDefaultListAPI } from '@/apis/form';
import * as echarts from 'echarts';

import { useTranslation } from 'react-i18next';

const EchartsPage = () => {
    const { t } = useTranslation();

    const chartRef = useRef(null);

    useEffect(() => {
        const chart = echarts.init(chartRef.current);
        getProjectFormDefaultListAPI()
            .then(res => res.data)
            .then(data => {
                const option = {
                    title: {
                        text: t("FormText.ProjectAccount")
                    },
                    xAxis: {
                        name: t("FormText.Months"),
                        type: 'category',
                        data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: data,
                        type: 'line'
                    }]
                };
                chart.setOption(option);
            })
        return () => {
            chart.dispose();
        };
    }, []);

    return (
        <div ref={chartRef} style={{ width: '600px', height: '400px', marginTop: '20px' }}></div>
    );
};

export default EchartsPage; 